import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
// Only the list fetch is cancellable: re-entering the page drops its stale request, while writes
// must never cancel each other.
let listCancelToken = null;

const baseUrl = () => `${Config.api.notification.url}user-notification-settings`;

class UserNotificationSettingsService {
  getUserNotificationSettings() {
    if (listCancelToken) {
      listCancelToken.cancel('Multiple requests.');
    }
    listCancelToken = CancelToken.source();

    return ApiService.get(baseUrl(), { cancelToken: listCancelToken.token }).then((response) => response.data);
  }

  // An omitted flag defaults to `true` server-side;
  addUserNotificationSetting({ notificationTypeId, isEmailSubscribed, isInAppSubscribed }) {
    return ApiService.post(baseUrl(), { notificationTypeId, isEmailSubscribed, isInAppSubscribed }).then(
      (response) => response.data,
    );
  }

  // Several types at once, same flags for all; a type the user already has a row for is returned as stored.
  addUserNotificationSettings({ notificationTypeIds, isEmailSubscribed, isInAppSubscribed }) {
    return ApiService.post(`${baseUrl()}/batch`, { notificationTypeIds, isEmailSubscribed, isInAppSubscribed }).then(
      (response) => response.data,
    );
  }

  // Partial update: only the flags passed change, the others keep their stored value.
  editUserNotificationSetting({ userNotificationSettingId, isEmailSubscribed, isInAppSubscribed }) {
    return ApiService.put(`${baseUrl()}/${userNotificationSettingId}`, { isEmailSubscribed, isInAppSubscribed }).then(
      (response) => response.data,
    );
  }

  deleteUserNotificationSetting(userNotificationSettingId) {
    return ApiService.delete(`${baseUrl()}/${userNotificationSettingId}`).then((response) => response.data);
  }

  getMarketSummarySections() {
    return ApiService.get(`${baseUrl()}/market-summary`).then((response) => response.data.sections || []);
  }

  updateMarketSummarySections(sections) {
    return ApiService.put(`${baseUrl()}/market-summary`, { sections }).then((response) => response.data.sections);
  }
}

const userNotificationSettingsService = new UserNotificationSettingsService();

export default userNotificationSettingsService;
